import { createApp } from 'vue'
import StafetOpretHoldFlow from './StafetOpretHoldFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-opret-hold-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetOpretHoldFlowDOM) => {
            const externalData = StafetOpretHoldFlowDOM.dataset.external
                ? JSON.parse(StafetOpretHoldFlowDOM.dataset.external)
                : null
            const props = {
                stafetId: externalData.stafetId ?? null,
                holdList: externalData.holdnavne ?? [],
                holdData: externalData.holdData ?? {},
                userData: externalData.userData ?? {},
                loggedIn: isObjectNotNullOrEmpty(externalData.userData)
            }
            const component = createApp(StafetOpretHoldFlow, props).use(Store)
            component.mount(StafetOpretHoldFlowDOM)
        })
    }
}
